export default __webpack_public_path__ + "static/media/next.c8004c01.svg";